import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'
import { useCheckoutStatusLazyQuery, usePurchaseTicketMutation } from 'graphql/generated/scheme'
import { PendingCheckout, SettleCheckoutOptions, settleCheckout } from 'utils/checkout-recovery'

const wait = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms))

/** settleCheckout wired to the real purchaseTicket and checkoutStatus calls */
export function useSettleCheckout() {
	const [purchaseTicket] = usePurchaseTicketMutation()
	const [fetchCheckoutStatus] = useCheckoutStatusLazyQuery({ fetchPolicy: 'no-cache' })

	return useCallback(
		(checkout: PendingCheckout, options?: SettleCheckoutOptions) =>
			settleCheckout(
				checkout,
				{
					getStatus: async sessionId => {
						const { data, error } = await fetchCheckoutStatus({ variables: { paymentReferenceId: sessionId } })
						if (!data) throw error ?? new Error('No checkout status')
						return data.eventTicket.checkoutStatus
					},
					purchase: async ({ orderId, eventId, context, contestEntry, memberEventId }) => {
						try {
							const { data } = await purchaseTicket({
								variables: { orderId, eventId, context, contestEntry, memberEventId },
							})
							return !!data?.eventTicket.purchaseTicket.success
						} catch (error) {
							// The server answered with an error: refused this time (settleCheckout tries again while still PAID)
							if (error instanceof ApolloError && !error.networkError) return false
							throw error
						}
					},
					wait,
				},
				options
			),
		[purchaseTicket, fetchCheckoutStatus]
	)
}
